import PageLogin from '@/pages/PageLogin'
import PageSignup from '@/pages/PageSignup'
import PageAfterSignup from '@/pages/PageAfterSignup'
import PageResetPassword from '@/pages/PageResetPassword'
import PageDashboard from '@/pages/PageDashboard'
import PageMyBots from '@/pages/PageMyBots'
import PageStrategies from '@/pages/PageStrategies'
import PageStrategyDetail from '@/pages/PageStrategyDetail'
import PageEditBot from '@/pages/PageEditBot'
import PageCreateBot from '@/pages/PageCreateBot'
import PageProfile from '@/pages/PageProfile'
import PageHelp from '@/pages/PageHelp'
import PageSubscription from '@/pages/PageSubscription'
import PageFeedback from '@/pages/PageFeedback'
import PageTrendRadar from '@/pages/PageTrendRadar'
import PageNotFound from '@/pages/PageNotFound'
import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Login',
    component: PageLogin
  },
  {
    path: '/login',
    name: 'Login2',
    component: PageLogin
  },
  {
    path: '/signup',
    name: 'Signup',
    component: PageSignup
  },
  {
    path: '/afterSignup',
    name: 'AfterSignup',
    component: PageAfterSignup
  },
  {
    path: '/resetPassword',
    name: 'ResetPassword',
    component: PageResetPassword
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: PageDashboard
  },
  {
    path: '/bots',
    name: 'MyBots',
    component: PageMyBots
  },
  {
    path: '/strategies',
    name: 'Strategies',
    component: PageStrategies
  },
  {
    path: '/strategy/:strategyName',
    name: 'StrategyDetail',
    component: PageStrategyDetail,
    props: true
  },
  // Legacy strategy URLs - redirect to new dynamic routes
  {
    path: '/gaussianChannelStrategy',
    redirect: { name: 'StrategyDetail', params: { strategyName: 'GAUSSIAN_CHANNEL' } }
  },
  {
    path: '/ichimokuEma4hStrategy',
    redirect: { name: 'StrategyDetail', params: { strategyName: 'ICHIMOKU_EMA_4H' } }
  },
  {
    path: '/createBot',
    name: 'CreateNewBot',
    component: PageCreateBot
  },
  {
    path: '/bot/:id',
    name: 'EditBot',
    component: PageEditBot,
    props: true
  },
  {
    path: '/me',
    name: 'Profile',
    component: PageProfile
  },
  {
    path: '/help',
    name: 'Help',
    component: PageHelp
  },
  {
    path: '/subscription',
    name: 'Subscription',
    component: PageSubscription
  },
  {
    path: '/feedback/:pathMatch(.*)*',
    name: 'Feedback',
    component: PageFeedback
  },
  {
    path: '/trendradar',
    name: 'TrendRadar',
    component: PageTrendRadar
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: PageNotFound
  }
]

export default createRouter({
  history: createWebHashHistory(),
  linkActiveClass: 'active',
  routes,
  scrollBehavior() {
    document.getElementById('app').scrollIntoView({ behavior: 'smooth' });
  }
})
